const convertToTitleCase = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1)

export const getFullNameFromEmail = (email: string): string => {
  if (!email) return ''
  const emailNamePart = email.split('@')[0]
  const splitter = emailNamePart.includes('.') ? '.' : '-'
  const [firstName, ...rest] = emailNamePart.split(splitter)
  const lastName = rest.join(' ')
  return `${convertToTitleCase(firstName)} ${convertToTitleCase(lastName)}`
}
